// Maps an AI-tagged GA report category to the canonical GA4 report slug,
// then builds a clickable deep-link into the user's own Google Analytics
// property for any insight (wins / watch-outs / suggestions).
//
// The AI is constrained to pick one of GA_REPORT_KEYS for every insight so the
// frontend has a stable contract — unknown values fall back to the home page.

export const GA_REPORT_KEYS = [
  "traffic-acquisition",
  "user-acquisition",
  "engagement-overview",
  "engagement-pages",
  "engagement-events",
  "conversions",
  "tech-overview",
  "demographics-overview",
  "realtime",
  "retention",
];

const GA_REPORT_SLUGS = {
  "traffic-acquisition": "acquisition-traffic-acquisition",
  "user-acquisition": "acquisition-user-acquisition",
  "engagement-overview": "engagement-overview",
  "engagement-pages": "engagement-pages-and-screens",
  "engagement-events": "engagement-events",
  "conversions": "engagement-conversions",
  "tech-overview": "tech-overview",
  "demographics-overview": "demographics-overview",
  "realtime": "realtime",
  "retention": "retention",
};

const GA_REPORT_LABELS = {
  "traffic-acquisition": "Traffic acquisition",
  "user-acquisition": "User acquisition",
  "engagement-overview": "Engagement overview",
  "engagement-pages": "Pages & screens",
  "engagement-events": "Events",
  "conversions": "Key events",
  "tech-overview": "Tech overview",
  "demographics-overview": "Demographics",
  "realtime": "Realtime",
  "retention": "Retention",
};

// Build a GA4 deep link. Returns null when there is no GA property attached
// (e.g. CSV / demo analyses) so the UI can hide the link entirely.
export function buildGaReportUrl(propertyId, gaReport, period) {
  if (!propertyId) return null;
  const slug = GA_REPORT_SLUGS[gaReport] || "intelligenthome";
  const base = `https://analytics.google.com/analytics/web/#/p${propertyId}/reports/${slug}`;
  // Preserve the analysis's date range so the user lands on the same window.
  if (period && period.start && period.end) {
    const s = period.start.replaceAll("-", "");
    const e = period.end.replaceAll("-", "");
    return `${base}?params=_u..nav%3Dmaui%26_u.date00%3D${s}%26_u.date01%3D${e}`;
  }
  return base;
}

export function gaReportLabel(gaReport) {
  return GA_REPORT_LABELS[gaReport] || "Google Analytics";
}
